import script from "./DisplayAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisplayAccount.vue?vue&type=script&setup=true&lang=ts"

import "./DisplayAccount.vue?vue&type=style&index=0&id=2768ce2b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2768ce2b"]])

export default __exports__